var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocationAno(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 14C12.5304 14 13.0391 13.7893 13.4142 13.4142C13.7893 13.0391 14 12.5304 14 12C14 11.4696 13.7893 10.9609 13.4142 10.5858C13.0391 10.2107 12.5304 10 12 10C11.4696 10 10.9609 10.2107 10.5858 10.5858C10.2107 10.9609 10 11.4696 10 12C10 12.5304 10.2107 13.0391 10.5858 13.4142C10.9609 13.7893 11.4696 14 12 14Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6561 5.40225H17.6569C20.781 8.60525 20.781 13.799 17.6569 17.002L13.3344 21.4337C12.9804 21.7963 12.5004 22 12 22C11.4996 22 11.0196 21.7963 10.6656 21.4337L6.36546 17.0249L6.34306 17.002C3.21898 13.799 3.21898 8.60525 6.34306 5.40225C9.46634 2.19925 14.5321 2.19925 17.6561 5.40225ZM7.19108 6.2717C5.916 7.57917 5.19968 9.35319 5.19968 11.2021C5.19968 13.051 5.916 14.8242 7.19108 16.1317L7.20948 16.1514L7.21108 16.153L11.5136 20.5642C11.6424 20.6962 11.8171 20.7703 11.9992 20.7703C12.1813 20.7703 12.356 20.6962 12.4848 20.5642L16.8073 16.1317C18.0673 14.821 18.7708 13.0528 18.7644 11.2125C18.758 9.37218 18.0421 7.60913 16.7729 6.30779C15.5037 5.00644 13.7842 4.27235 11.9893 4.26559C10.1943 4.25882 8.46955 4.97994 7.19108 6.2717Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationAno);
export default __webpack_public_path__ + "static/media/location_ano.237b4722dcd50bd63bf9e379eddf2176.svg";
export { ForwardRef as ReactComponent };